var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenStandards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 372,
    viewBox: "0 0 367 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_9984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.733 340.507C336.636 340.507 336.539 340.507 336.443 340.507L33.7223 309.96C32.7571 309.863 31.8885 309.284 31.4059 308.415C30.9233 307.547 30.9233 306.533 31.3577 305.616L122.179 124.023C122.565 123.25 123.24 122.72 124.012 122.478L320.904 66.2098L33.7223 37.4964C32.0815 37.3516 30.8751 35.8556 31.0681 34.2149C31.2129 32.5741 32.7089 31.3677 34.3496 31.5607L337.07 61.8183C338.518 61.9631 339.628 63.073 339.725 64.5207C339.869 65.9685 338.952 67.2714 337.553 67.6575L126.908 127.835L38.5963 304.41L336.974 334.523C338.615 334.667 339.821 336.163 339.628 337.804C339.531 339.348 338.229 340.507 336.733 340.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0196 64.8104C50.7304 64.8104 64.2772 51.2636 64.2772 34.5528C64.2772 17.842 50.7304 4.29517 34.0196 4.29517C17.3088 4.29517 3.76196 17.842 3.76196 34.5528C3.76196 51.2636 17.3088 64.8104 34.0196 64.8104Z",
    fill: "url(#paint0_linear_1035_9984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.026 49.6092C20.2243 49.6092 8.15988 40.2954 4.73358 26.928C0.583417 43.0944 10.3315 59.5985 26.4978 63.7969C42.6642 67.9954 59.1683 58.199 63.3667 42.0327C64.6214 37.0622 64.6214 31.8986 63.3667 26.928C59.8922 40.2954 47.8277 49.6574 34.026 49.6092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.714 95.068C353.425 95.068 366.972 81.5212 366.972 64.8104C366.972 48.0996 353.425 34.5528 336.714 34.5528C320.003 34.5528 306.457 48.0996 306.457 64.8104C306.457 81.5212 320.003 95.068 336.714 95.068Z",
    fill: "url(#paint1_linear_1035_9984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.728 79.9151C322.926 79.9151 310.862 70.6013 307.435 57.2339C303.285 73.4003 313.033 89.9044 329.199 94.1028C345.366 98.253 361.87 88.5049 366.068 72.3386C367.323 67.3681 367.323 62.2045 366.068 57.2339C362.594 70.5531 350.529 79.9151 336.728 79.9151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.173 195.637C292.884 195.637 306.431 182.09 306.431 165.379C306.431 148.668 292.884 135.122 276.173 135.122C259.462 135.122 245.916 148.668 245.916 165.379C245.916 182.09 259.462 195.637 276.173 195.637Z",
    fill: "url(#paint2_linear_1035_9984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18 180.532C262.378 180.532 250.314 171.219 246.887 157.851C242.737 174.017 252.485 190.522 268.652 194.72C284.818 198.918 301.322 189.122 305.52 172.956C306.775 167.985 306.775 162.822 305.52 157.851C302.046 171.219 289.981 180.532 276.18 180.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.714 367.772C353.425 367.772 366.972 354.225 366.972 337.515C366.972 320.804 353.425 307.257 336.714 307.257C320.003 307.257 306.457 320.804 306.457 337.515C306.457 354.225 320.003 367.772 336.714 367.772Z",
    fill: "url(#paint3_linear_1035_9984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.728 352.668C322.926 352.668 310.862 343.354 307.435 329.986C303.285 346.153 313.033 362.657 329.199 366.855C345.366 371.006 361.87 361.257 366.068 345.091C367.323 340.121 367.323 334.957 366.068 329.986C362.594 343.306 350.529 352.668 336.728 352.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.103 142.843L124.845 160.312L94.5878 142.843V107.856L124.845 90.3868L155.103 107.856V142.843Z",
    fill: "url(#paint4_linear_1035_9984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.845 160.312V125.325L94.5878 107.856V142.843L124.845 160.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0141 265.37L0.716309 315.316L34.0141 348.614L67.312 315.316L34.0141 265.37Z",
    fill: "url(#paint5_linear_1035_9984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0141 325.499V265.37L0.716309 315.316L34.0141 348.614V325.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26918 99.3628C1.90455 99.3628 -0.0257568 97.4325 -0.0257568 95.0678C-0.0257568 92.7032 1.90455 90.7729 4.26918 90.7729C6.63381 90.7729 8.56412 92.7032 8.56412 95.0678C8.51586 97.4325 6.58555 99.3628 4.26918 99.3628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2572 129.62C61.8926 129.62 59.9623 127.69 59.9623 125.325C59.9623 122.961 61.8926 121.031 64.2572 121.031C66.6218 121.031 68.5522 122.961 68.5522 125.325C68.5522 127.738 66.6218 129.62 64.2572 129.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.826 250.699C122.461 250.699 120.531 248.769 120.531 246.404C120.531 244.039 122.461 242.109 124.826 242.109C127.191 242.109 129.121 244.039 129.121 246.404C129.073 248.817 127.191 250.699 124.826 250.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9995 190.184C31.6349 190.184 29.7046 188.254 29.7046 185.889C29.7046 183.524 31.6349 181.594 33.9995 181.594C36.3642 181.594 38.2945 183.524 38.2945 185.889C38.2462 188.254 36.3642 190.184 33.9995 190.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.096 84.2101C152.732 84.2101 150.802 82.2798 150.802 79.9152C150.802 77.5506 152.732 75.6202 155.096 75.6202C157.461 75.6202 159.343 77.5023 159.391 79.8669C159.391 82.2798 157.509 84.2101 155.096 84.2101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.424 250.699C304.06 250.699 302.129 248.769 302.129 246.404C302.129 244.039 304.06 242.109 306.424 242.109C308.789 242.109 310.719 244.039 310.719 246.404C310.719 248.817 308.789 250.699 306.424 250.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.895 281.005C243.531 281.005 241.6 279.075 241.6 276.71C241.6 274.345 243.531 272.415 245.895 272.415C248.26 272.415 250.19 274.345 250.19 276.71C250.142 279.075 248.26 280.957 245.895 281.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.721 190.184C334.356 190.184 332.426 188.254 332.426 185.889C332.426 183.524 334.356 181.594 336.721 181.594C339.086 181.594 341.016 183.524 341.016 185.889C340.968 188.254 339.086 190.184 336.721 190.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.721 129.62C334.356 129.62 332.426 127.69 332.426 125.325C332.426 122.961 334.356 121.031 336.721 121.031C339.086 121.031 341.016 122.961 341.016 125.325C340.968 127.738 339.086 129.62 336.721 129.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.166 8.54196C273.801 8.54196 271.871 6.61165 271.871 4.24703C271.871 1.8824 273.801 -0.0479126 276.166 -0.0479126C278.531 -0.0479126 280.461 1.8824 280.461 4.24703C280.461 6.61165 278.531 8.54196 276.166 8.54196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.341 8.54196C182.976 8.54196 181.046 6.61165 181.046 4.24703C181.046 1.8824 182.976 -0.0479126 185.341 -0.0479126C187.705 -0.0479126 189.636 1.8824 189.636 4.24703C189.636 6.61165 187.705 8.54196 185.341 8.54196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5675 341.52C92.2029 341.52 90.2726 339.59 90.2726 337.225C90.2726 334.86 92.2029 332.93 94.5675 332.93C96.9321 332.93 98.8625 334.86 98.8625 337.225C98.8142 339.59 96.8839 341.52 94.5675 341.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.096 371.778C152.732 371.778 150.802 369.847 150.802 367.483C150.802 365.118 152.732 363.188 155.096 363.188C157.461 363.188 159.391 365.118 159.391 367.483C159.391 369.896 157.461 371.778 155.096 371.778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.638 341.52C213.273 341.52 211.343 339.59 211.343 337.225C211.343 334.86 213.273 332.93 215.638 332.93C218.002 332.93 219.933 334.86 219.933 337.225C219.884 339.59 218.002 341.52 215.638 341.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.096 190.329C152.732 190.329 150.802 188.398 150.802 186.034C150.802 183.669 152.732 181.739 155.096 181.739C157.461 181.739 159.391 183.669 159.391 186.034C159.391 188.398 157.461 190.28 155.096 190.329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.638 144.773C213.273 144.773 211.343 142.843 211.343 140.478C211.343 138.114 213.273 136.183 215.638 136.183C218.002 136.183 219.933 138.114 219.933 140.478C219.884 142.843 218.002 144.773 215.638 144.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.653 264.597L185.347 282.067L155.09 264.597V229.659L185.347 212.189L215.653 229.659V264.597Z",
    fill: "url(#paint6_linear_1035_9984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.347 282.067V247.128L155.09 229.659V264.597L185.347 282.067Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1035_9984",
    x1: 4673.11,
    y1: 7461.58,
    x2: 13668.1,
    y2: 7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1035_9984",
    x1: 4975.81,
    y1: 7491.84,
    x2: 13970.8,
    y2: 7963.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1035_9984",
    x1: 4915.27,
    y1: 7592.41,
    x2: 13910.2,
    y2: 8063.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1035_9984",
    x1: 4975.81,
    y1: 7764.54,
    x2: 13970.8,
    y2: 8235.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1035_9984",
    x1: 4763.94,
    y1: 8707.3,
    x2: 13765.1,
    y2: 9115.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1035_9984",
    x1: 5139.24,
    y1: 10523.6,
    x2: 15047.8,
    y2: 10939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1035_9984",
    x1: 4828.17,
    y1: 8823.15,
    x2: 13836.5,
    y2: 9232.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_9984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 367,
    height: 371.778,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenStandards);
export default __webpack_public_path__ + "static/media/tokenStandards.c23a1fdff3550ad791809e6fb4d25d04.svg";
export { ForwardRef as ReactComponent };